import { useQuery } from "convex/react";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/convex-api";
import { ProjectViewPage } from "@/features/project/project-view-page";
import { projectSelectRoute } from "@/lib/app-routes";

export function ProjectRoutePage({
  orgSlug,
  projectSlug,
  noFileRoutePath,
}: {
  orgSlug: string;
  projectSlug: string;
  noFileRoutePath: typeof projectSelectRoute;
}) {
  const project = useQuery(api.projects.getBySlugs, {
    organizationSlug: orgSlug,
    projectSlug,
  });

  if (project === undefined) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loader2 className="size-5 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!project) {
    return (
      <div className="flex h-full items-center justify-center text-sm text-muted-foreground">
        Project not found.
      </div>
    );
  }

  return (
    <ProjectViewPage projectId={project.id} noFileRoutePath={noFileRoutePath} />
  );
}
